import { Checkbox } from "@sprout/checkbox.tsx";
import { useTranslation } from "react-i18next";
import { LocationInput } from "@components/ui/location_input.tsx";
import { AsyncMultiSelect, MultiSelect, Option, SingleSelect } from "@sprout/select";
import { WorkPreferencesFormType as WorkPreferencesFormType } from "@hooks/use_work_preferences_form.ts";

type Props = {
  form: WorkPreferencesFormType;
  className: string;
  languagesHelperText: string;
  worksiteOptions: Option[];
  employmentTypeOptions: Option[];
  locationHelperText: string;
};
const WorkPreferencesForm = ({
  form,
  className,
  languagesHelperText,
  worksiteOptions,
  employmentTypeOptions,
  locationHelperText,
}: Props) => {
  const { t } = useTranslation("user");

  return (
    <div className={className}>
      <LocationInput
        value={form.location}
        onChange={form.setLocation}
        helperText={locationHelperText}
      />
      <Checkbox
        id="relocation"
        options={[{ value: "1", label: t("workPreferences.willingToRelocate") }]}
        onSelect={() => form.setRelocation(!form.relocation)}
        values={form.relocation ? ["1"] : []}
        error={form.relocationError}
        isMulti
      />
      <SingleSelect
        clearable
        onChange={form.setSalary}
        options={form.salaryOptions}
        value={form.salary}
        label={t("workPreferences.salary.label")}
      />
      <MultiSelect
        clearable
        onChange={form.setWorksites}
        options={worksiteOptions}
        values={form.worksites}
        label={t("workPreferences.worksites.label")}
      />
      <MultiSelect
        onChange={form.setEmploymentTypes}
        options={employmentTypeOptions}
        values={form.employmentTypes}
        label={t("workPreferences.employmentTypes.label")}
        clearable
      />
      <AsyncMultiSelect
        onChange={form.handleUpdateLanguages}
        values={form.languages}
        label={t("workPreferences.languages.label")}
        helperText={languagesHelperText}
        error={form.languageError}
        clearable
        loadOptions={form.loadLanguageOptions}
      />
    </div>
  );
};

export default WorkPreferencesForm;
